module.exports = __webpack_public_path__ + "static/city_step07-7c881ab88f244e0c20cbd0dc0ad687b9.png";